// pages/promotions/PromotionHero.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Tabs, Tab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import ImageIcon from "@mui/icons-material/Image";
import SecureLS from "secure-ls";
import TitleSetter from "../../component/TitleSetter";
import StoreTitle from "../../component/StoreTitle";

const ls = new SecureLS({ encodingType: "aes" });

const PromotionHero = ({ title = "Promotions" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = ls.get("user");
  const role = user?.role || "";

  const currentTab = React.useMemo(() => {
    if (location.pathname.endsWith("/brands")) return 2;
    if (location.pathname.endsWith("/home")) return 1;
    return 0; // Overview
  }, [location.pathname]);

  const handleTabChange = (_e, val) => {
    if (val === 0) navigate("/promotions");
    if (val === 1) navigate("/promotions/home");
    if (val === 2) navigate("/promotions/brands");
  };

  return (
    <Box sx={{ padding: 3 }}>
      <TitleSetter title={title} />
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/dashboard")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>
      <Box sx={{ marginTop: -8, marginBottom: 2 }}>
        <StoreTitle title={title} />
      </Box>

      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        variant="fullWidth"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
          },
        }}
      >
        <Tab
          icon={<DashboardCustomizeIcon />}
          iconPosition="start"
          label="Overview"
        />
        <Tab icon={<WallpaperIcon />} iconPosition="start" label="Home Page" />
        <Tab icon={<ImageIcon />} iconPosition="start" label="Brandings" />
      </Tabs>
    </Box>
  );
};

export default PromotionHero;
